var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "tree" }, [
    _c(
      "div",
      {
        staticClass: "parent",
        class: {
          bold: _vm.isFolder,
          company: _vm.item.nombre === _vm.company.razonSocial,
          selected:
            _vm.selected && _vm.item.id === _vm.selected.id && _vm.item.id
        },
        attrs: { "data-cy": "company" }
      },
      [
        _vm.isFolder
          ? _c(
              "span",
              { on: { click: _vm.toggle } },
              [
                !_vm.isOpen
                  ? _c("feather-icon", {
                      staticClass: "cursor-pointer current-step ml-2",
                      attrs: { icon: "ChevronRightIcon" }
                    })
                  : _vm._e(),
                _vm.isOpen
                  ? _c("feather-icon", {
                      staticClass: "cursor-pointer current-step ml-2",
                      attrs: { icon: "ChevronDownIcon" }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _c(
          "span",
          [
            _vm.isInternOffice
              ? _c("feather-icon", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Es Oficina Interna",
                      expression: "'Es Oficina Interna'"
                    }
                  ],
                  staticClass: "cursor-default current-step ml-2 is-intern",
                  attrs: { size: "14", icon: "AwardIcon" }
                })
              : _vm._e(),
            _vm.isExternOffice
              ? _c("feather-icon", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Es Oficina Externa",
                      expression: "'Es Oficina Externa'"
                    }
                  ],
                  staticClass: "cursor-default current-step ml-2 is-extern",
                  attrs: { size: "14", icon: "AwardIcon" }
                })
              : _vm._e(),
            _vm.checkGroup
              ? _c("feather-icon", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Es Grupo",
                      expression: "'Es Grupo'"
                    }
                  ],
                  staticClass: "cursor-default current-step ml-2",
                  attrs: { size: "14", icon: "UsersIcon" }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "span",
          { staticClass: "pb-2 pl-2", on: { click: _vm.getChildren } },
          [_vm._v(" " + _vm._s(_vm.item.nombre) + " ")]
        ),
        _c("CheckPermission", { attrs: { permission: "ED074" } }, [
          _vm.item.type !== "subcategory" && _vm.item.type !== "category"
            ? _c(
                "div",
                { staticClass: "dropdown" },
                [
                  _c(
                    "b-dropdown",
                    {
                      attrs: {
                        "data-cy": "options",
                        variant: "link",
                        "toggle-class": "actions ml-2",
                        "no-caret": "",
                        left: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "p-0" },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "align-middle text-body p-0",
                                      attrs: {
                                        size: "18",
                                        icon: "PlusCircleIcon"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        171246545
                      )
                    },
                    [
                      _vm.item.nombre !== _vm.company.razonSocial &&
                      !_vm.isOffice
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "edit-group" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("edit-group", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Editar grupo ")]
                          )
                        : _vm._e(),
                      _vm.isOffice
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "edit-group" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("edit-group", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Editar oficina ")]
                          )
                        : _vm._e(),
                      !_vm.isOffice &&
                      _vm.item.nombre !== _vm.company.razonSocial
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "remove-group" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("remove-group", _vm.item)
                                }
                              }
                            },
                            [_c("span", [_vm._v(" Remover Grupo ")])]
                          )
                        : _vm._e(),
                      _vm.isOffice &&
                      _vm.item.nombre !== _vm.company.razonSocial
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "remove-group" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("remove-group", _vm.item)
                                }
                              }
                            },
                            [_c("span", [_vm._v(" Remover Oficina ")])]
                          )
                        : _vm._e(),
                      _vm.item.nombre !== _vm.company.razonSocial &&
                      !_vm.isOffice
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "add-sub-group" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("add-sub-group", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Agregar sub-grupo ")]
                          )
                        : _vm._e(),
                      _vm.item.nombre !== _vm.company.razonSocial &&
                      !_vm.isOffice
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "users-group" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("users-group", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Usuarios del grupo ")]
                          )
                        : _vm._e(),
                      _vm.item.nombre !== _vm.company.razonSocial &&
                      _vm.isOffice
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "users-group" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("users-group", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Usuarios de la oficina ")]
                          )
                        : _vm._e(),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED051" } },
                        [
                          _vm.item.nombre !== _vm.company.razonSocial &&
                          _vm.item.esOficina === "Y"
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "config-numeration" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit(
                                        "config-numeration",
                                        _vm.item
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" Numeración ")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.item.nombre === _vm.company.razonSocial &&
                      _vm.groupMood
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "add-group" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("add-group", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Agregar grupo ")]
                          )
                        : _vm._e(),
                      _vm.item.nombre === _vm.company.razonSocial &&
                      !_vm.groupMood
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "add-office" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("add-office", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Agregar oficina ")]
                          )
                        : _vm._e(),
                      _vm.groupMood
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "add-user" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("add-user", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Agregar usuario ")]
                          )
                        : _vm._e(),
                      _vm.groupMood
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "add-massive-users" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit(
                                    "add-massive-users",
                                    _vm.item
                                  )
                                }
                              }
                            },
                            [_vm._v(" Agregar usuarios masivo ")]
                          )
                        : _vm._e(),
                      _vm.item.nombre === _vm.company.razonSocial
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "remove-user" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("remove-user", _vm.item)
                                }
                              }
                            },
                            [_vm._v(" Remover usuario ")]
                          )
                        : _vm._e(),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "data-cy": "leader-group" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("leader-group", _vm.item)
                            }
                          }
                        },
                        [
                          !_vm.isOffice
                            ? _c("span", [_vm._v(" Líder de Grupo ")])
                            : _vm._e(),
                          _vm.isOffice
                            ? _c("span", [_vm._v(" Líder de Oficina ")])
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED115" } },
                        [
                          _vm.isOffice
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: {
                                    "data-cy": "config-entity-docdigital"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit(
                                        "config-entity-doc-digital",
                                        _vm.item
                                      )
                                    }
                                  }
                                },
                                [_vm._v(" Configurar entidad Doc Digital ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    ),
    _vm.isFolder && _vm.isOpen
      ? _c(
          "ul",
          _vm._l(_vm.item.children, function(child, index) {
            return _c("tree-item", {
              key: index,
              staticClass: "item",
              class: _vm.getClass(_vm.item),
              attrs: {
                item: child,
                selected: _vm.selected,
                groupMood: _vm.groupMood
              },
              on: {
                "get-children": function($event) {
                  return _vm.$emit("get-children", $event)
                },
                "edit-group": function($event) {
                  return _vm.$emit("edit-group", $event)
                },
                "add-group": function($event) {
                  return _vm.$emit("add-group", $event)
                },
                "add-office": function($event) {
                  return _vm.$emit("add-office", $event)
                },
                "users-group": function($event) {
                  return _vm.$emit("users-group", $event)
                },
                "leader-group": function($event) {
                  return _vm.$emit("leader-group", $event)
                },
                "add-sub-group": function($event) {
                  return _vm.$emit("add-sub-group", $event)
                },
                "add-user": function($event) {
                  return _vm.$emit("add-user", $event)
                },
                "add-massive-users": function($event) {
                  return _vm.$emit("add-massive-users", $event)
                },
                "remove-user": function($event) {
                  return _vm.$emit("remove-user", $event)
                },
                "remove-group": function($event) {
                  return _vm.$emit("remove-group", $event)
                },
                "config-numeration": function($event) {
                  return _vm.$emit("config-numeration", $event)
                },
                "config-entity-doc-digital": function($event) {
                  return _vm.$emit("config-entity-doc-digital", $event)
                }
              }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }